import { NativeContainerElementCommonCode1o0vbwacxxrc9 as NativeContainerElementCommonCode } from './NativeContainerElement.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NativeContainerElementClass;
function NativeContainerElement() {
  if (NativeContainerElementClass === VOID) {
    class $ extends NativeContainerElementCommonCode() {
      nativeAddChild_hge4nv_k$(index, element) {
        this.native_1.appendChild_9oez1i_k$(index, element.get_underlyingNativeElement_vngz33_k$().native_1);
      }
      nativeRemoveChild_8vu7sp_k$(index) {
        this.native_1.removeChild_mjbjbk_k$(index);
      }
      nativeClearChildren_cy0j45_k$() {
        this.native_1.clearChildren_eufjq4_k$();
      }
    }
    initMetadataForClass($, 'NativeContainerElement');
    NativeContainerElementClass = $;
  }
  return NativeContainerElementClass;
}
//region block: exports
export {
  NativeContainerElement as NativeContainerElement390em0tm6yzca,
};
//endregion

//# sourceMappingURL=NativeContainerElement.commonHtml.mjs.map
